import { Dispatch, FC } from 'react';
import { useFormContext } from 'react-hook-form';
import FormFieldComponent from '@/components/FormFieldComponent';
import { FormFieldSelect } from '@/components/FormFieldSelect';
import FormFieldPhone from '@/components/FormFieldPhone';
import { NAME_VALIDATION, EMAIL_ADDRESS_VALIDATION, FAX_REPLACE_REGEX, Employee_type } from '@/utils/constant';
import { Contact } from '@/components/ContactForm';

interface ContactFormSectionProps {
  contacts: Contact[];
  currentContactIndex: number;
  activeContactId: string;
  setContacts: Dispatch<React.SetStateAction<Contact[]>>;
  resetDataExchangeEmails: () => void;
  type?: string;
}

export const ClientContactFormSection: FC<ContactFormSectionProps> = ({
  contacts,
  currentContactIndex,
  activeContactId,
  setContacts,
  resetDataExchangeEmails,
}) => {
  const { control, watch, getValues, setValue } = useFormContext();
  const phone = watch(`contacts[${currentContactIndex}].phone`) as string;
  const type = watch(`contacts[${currentContactIndex}].type`) as string;

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-col gap-6">
        <div className="grid grid-cols-2 gap-6">
          <FormFieldComponent
            control={control}
            name={`contacts[${currentContactIndex}].firstName`}
            label="First Name"
            placeholder="Enter First Name"
            required
            onChange={(e) => {
              const newPersons = [...contacts];
              {
                const person = newPersons.find((p) => p.id === activeContactId);
                const lastName = (getValues(`contacts[${currentContactIndex}].lastName`) as string) ?? '';
                if (person) {
                  person.name = e.target.value ?? '' + ' ' + lastName;
                }
              }
              setContacts(newPersons);
            }}
            {...NAME_VALIDATION}
          />
          <FormFieldComponent
            control={control}
            name={`contacts[${currentContactIndex}].lastName`}
            label="Last Name"
            placeholder="Enter Last Name"
            required
            onChange={(e) => {
              const newPersons = [...contacts];
              const firstName = getValues(`contacts[${currentContactIndex}].firstName`) as string;
              const person = newPersons.find((p) => p.id === activeContactId);
              if (person) {
                person.name = firstName ? firstName + ' ' + e.target.value : e.target.value;
              }
              setContacts(newPersons);
            }}
            {...NAME_VALIDATION}
          />
        </div>

        <div className="grid grid-cols-2 gap-6">
          <FormFieldSelect
            name={`contacts[${currentContactIndex}].type`}
            label="Employee Type"
            placeholder="Select Employee Type"
            options={Employee_type}
            required
            className="focus:border-focuscolor"
            onChange={() => {
              setValue(`contacts[${currentContactIndex}].lawyerBarId`, null);
            }}
          />
          {type === 'LAWYER' && (
            <FormFieldComponent
              control={control}
              name={`contacts[${currentContactIndex}].lawyerBarId`}
              label="Lawyer Bar ID"
              allowSpecialCharacters={false}
              placeholder="Enter Lawyer Bar ID"
              replaceRegex={/\s+/g}
              maxLength={15}
            />
          )}
        </div>

        <div className="grid grid-cols-2 gap-6">
          <FormFieldComponent
            control={control}
            name={`contacts[${currentContactIndex}].email`}
            label="Email Address"
            placeholder="Enter Email Address"
            required
            onBlur={resetDataExchangeEmails}
            {...EMAIL_ADDRESS_VALIDATION}
          />
          <FormFieldComponent
            control={control}
            name={`contacts[${currentContactIndex}].fax`}
            label="Fax"
            placeholder="Enter Fax"
            replaceRegex={FAX_REPLACE_REGEX}
          />
        </div>
        <div className="grid grid-cols-3 gap-6">
          <FormFieldPhone
            name={`contacts[${currentContactIndex}].phone`}
            label="Phone Number"
            defaultCountry="us"
            onChange={(value) => {
              if (!value || value == '') {
                setValue(`contacts[${currentContactIndex}].extension`, null);
              }
            }}
          />
          <FormFieldComponent
            control={control}
            name={`contacts[${currentContactIndex}].extension`}
            label="Extension"
            placeholder="Enter Extension"
            disabled={!phone}
            maxLength={5}
          />
          <FormFieldPhone name={`contacts[${currentContactIndex}].cell`} label="Cell Number" />
        </div>
      </div>
    </div>
  );
};
